import {IObjectMap} from './IObjectMap';
import {ILocation} from './ILocation';

export interface IReservationRequest {
  visitor: string;
  reservationDate: string;
  fields: IObjectMap<string>;
  scemId: string;
  etaEnabled?: boolean;
}

export interface IReservationsRequest {
  fromDate: string;
  toDate: string;
  withStatuses: string[];
  locations: string[];
  page: number;
  radius?: number;
  latitude?: number;
  longitude?: number;
  orderBy?: string;
  orderDirection?: string;
  onlyExistingVisitors?: boolean;
  resultsPerPage: number;
  visitor?: string;
  fields?: IObjectMap<string>;
}

export interface IReservationsResponse {
  currentPage: number;
  resultsPerPage: number;
  totalPages: number;
  totalResults: number;
  items: IReservation[];
  isEmpty: true;
  isNotEmpty: true;
}

export enum ETA_STATUS {
  notStarted = 'notStarted',
  started = 'started',
  paused = 'paused',
  arrived = 'arrived',
  cancelled = 'cancelled',
}

export interface IReservation {
  checkinAllowedFrom: string;
  checkinAllowedTo: string;
  checkinIds?: string[];
  createdAt: string;
  creator: string;
  eta: string;
  etaEnabled: boolean;
  etaLastUpdated: string;
  etaStatus: ETA_STATUS;
  fields: IObjectMap<string>;
  fieldsJson: string;
  id: string;
  location?: ILocation;
  mandatoryFieldsIfNoVisitor: string;
  reservationDate: string;
  scemId: string;
  status: string;
  visitor: string;
  visitorExists: true;
}

export enum ReservationStatus {
  new = 'new',
  checkedIn = 'checkedIn'
}
